import { Routes } from '@angular/router';

export const DOCS_ROUTES: Routes = [
  {
    path: 'docs',
    loadComponent: () =>
      import('./pages/docs/docs-landing.component').then((m) => m.DocsLandingComponent),
  },
  // Each partner endpoint has its own page; the bare list lives on the overview.
  { path: 'docs/api', pathMatch: 'full', redirectTo: 'docs' },
  {
    path: 'docs/api/:slug',
    loadComponent: () =>
      import('./pages/docs-endpoint/docs-endpoint.component').then((m) => m.DocsEndpointComponent),
  },
];
